import React from 'react';

import { Clients } from '@ariksa/notification';
import { ClientsApiEditClientRequest } from '@ariksa/notification/api';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import { selectIntegrations } from 'containers/Setup/Integrations/selectors';
import { actions } from 'containers/Setup/Integrations/slice';

import { SlackForm } from './SlackForm';

export const EditSlack: React.FC = () => {
  const { activeClient } = useSelector(selectIntegrations);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const onUpdate = data => {
    const { name } = data;

    const payload: ClientsApiEditClientRequest = {
      uuid: activeClient.data?.uuid,
      editClientConfig: {
        name,
      },
    };
    dispatch(
      actions.updateClientById({
        q: payload,
        onSuccess: () => navigate('/setup/integrations/' + Clients.Slack),
      }),
    );
  };

  return <SlackForm handleSubmit={onUpdate} actionType="Update" />;
};
